module.exports = __webpack_public_path__ + "img/m-inf.fde4c77c.webp";